<template>
  <el-dialog
    append-to-body
    v-dialogDrag
    title="选择题源"
    class="mid-dialog"
    :visible.sync="pointProps.visible"
    :close-on-click-modal="false"
    @close="$emit('cancel')"
  >
    <div class="flex mb-10px mr-10px">
      <el-select
        class="mr-10px !w-50"
        ref="chapterSelectRef"
        v-model="searchData.chapterId"
        placeholder="所属章节"
        popper-class="chapter-select-tree"
        size="small"
        clearable
        @visible-change="chapterSelectChange"
        @clear="clearSelect"
      >
        <el-option
          :label="chapterName"
          :value="searchData.chapterId"
          :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
        >
          <el-tree
            :props="{
              label: 'questionBankName',
              children: 'childs',
            }"
            class="text-white max-h-274px overflow-x-hidden chapter-tree"
            ref="chapterTreeRef"
            node-key="id"
            highlight-current
            :data="chapterData"
            @node-click="treeNodeClick"
            :expand-on-click-node="false"
            :default-expanded-keys="defaultExpandedKeys"
          >
            <div slot-scope="{ data }" class="text-color-primary">
              {{ data.questionBankName || data.chapterName }}
            </div>
          </el-tree>
        </el-option>
      </el-select>
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="题目模糊搜索"
        maxlength="50"
        v-model="searchData.topic"
        clearable
      ></el-input>
      <el-select
        v-if="pageOrigin !== 'exam'"
        v-model="searchData.examType"
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择题目类型"
        clearable
        filterable
        multiple
        collapse-tags
      >
        <el-option
          v-for="item in questionList"
          :key="item.code"
          :label="item.displayName"
          :value="item.code"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
      <el-button size="small" type="primary" @click="resetText()">重置</el-button>
    </div>
    <el-table
      :data="dataList"
      border
      class="w-full mb-20px"
      :height="tableHeight"
      stripe
      v-loading="tableLoading"
      @selection-change="handleSelection"
      :row-key="getRowKey"
    >
      <el-table-column
        type="selection"
        :selectable="isDisabled"
        width="50"
        align="center"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="题目及答案" prop="name">
        <template slot-scope="scope">
          <question-content-view
            :key="scope.row.id"
            :row="scope.row"
            :index="scope.$index"
            :pageConfig="pageConfig"
          ></question-content-view>
        </template>
      </el-table-column>
      <el-table-column
        label="所属章节"
        width="150"
        prop="chapterName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="题目重要性" width="100" prop="importantName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="题目类型" prop="examType" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ questionListMap(scope.row) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="tableSizeChange"
      @current-change="tableCurrentChange"
      :current-page.sync="pageConfig.SkipCount"
      :page-size.sync="pageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="totalCount"
      class="float-right mt-20px ml-10px"
    ></el-pagination>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="submitForm">确定</el-button>
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { QuestionSourceApi, QuestionBankApi, QuestionChapterApi } from '@wiz-api/exam-management'
import { map, find } from 'lodash'
import utils from '@/components/safety/enumField/utils'
import { typeList } from './EnumField'
import QuestionContentView from './QuestionContentView'

const questionSourceApi = new QuestionSourceApi()
const questionBankApi = new QuestionBankApi()
const questionChapterApi = new QuestionChapterApi()
export default {
  name: 'choose-topic-origin-form',
  components: {
    QuestionContentView,
  },
  props: {
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    pointProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
        }
      },
    },
    // 已选题源集合
    taskIds: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 过滤字段，培训管理有此要求，不能选择题型，组件外传入过滤
    filterField: {
      type: Number,
      default: null,
    },
    // 页面来源
    pageOrigin: {
      type: String,
      default: 'topic',
    },
  },
  data() {
    return {
      tableLoading: false,
      // 题目类型
      questionList: typeList,
      selectionData: [],
      dataList: [],
      searchData: {
        topic: '',
        chapterId: '',
        examType: [],
      },
      totalCount: 0,
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      defaultExpandedKeys: [],
      chapterName: '',
      currentNode: {},
      chapterData: [],
      questionImportantList: [],
      chapterList: [],
    }
  },
  async mounted() {
    if (this.pageOrigin === 'exam') {
      this.searchData.examType = [this.filterField]
    }
    await utils.getDataCategory(
      ['ExamManagement.DataCategory.QuestionImportance'],
      ['questionImportantList'],
      this
    )
    await this.getChapterList()
    await this.getList()
    this.getChapterData()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 120px)'
    },
    questionListMap() {
      return (val) => {
        return (
          _.find(this.questionList, (item) => {
            return item.code === val.examType
          })?.displayName || ''
        )
      }
    },
  },
  methods: {
    clearSelect() {
      this.chapterName = ''
      this.currentNode = {}
    },
    async getChapterData() {
      const [err, res] = await questionBankApi.getTreeList()
      if (!err) {
        this.chapterData = res
      }
    },
    chapterSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.chapterTreeRef.setCurrentKey(this.searchData.chapterId) // 设置选中元素
          this.defaultExpandedKeys = [this.searchData.chapterId]
        } else {
          const nodeDatas = this.$refs.chapterTreeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(node) {
      this.currentNode = node
      this.searchData.chapterId = node.chapterId || node.id
      this.chapterName = node.chapterName || node.questionBankName
      this.$refs.chapterSelectRef.blur()
    },
    // 重置
    resetText() {
      if (this.pageOrigin === 'exam') {
        this.searchData.topic = ''
      } else {
        this.searchData = this.$options.data().searchData
      }
      this.handleSearch()
    },
    getRowKey(row) {
      return row.id
    },
    // 禁用复选框 0禁用 1不禁用
    isDisabled(row) {
      if (this.taskIds?.length > 0 && this.taskIds.includes(row.id)) {
        return 0
      }
      return 1
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values
    },
    // 表单提交
    async submitForm() {
      if (this.selectionData?.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择题源',
          type: 'warning',
        })
        return
      }
      // 页面来源,pageOrigin未topic题库管理和培训管理，抛出当前数据；exam，教育管理，抛出特定的数据格式
      if (this.pageOrigin === 'topic') {
        const selectionData = _.map(this.selectionData, (item) => {
          return item
        })
        this.$emit('add-risk-point', selectionData)
      } else if (this.pageOrigin === 'exam') {
        // exam，教育管理，抛出特定的数据格式
        const selectionData = _.map(this.selectionData, (item) => {
          return item
        })
        this.$emit('add-type-question', selectionData)
      }

      // 点击确定后,清空选择数据
      this.selectionData = []
    },
    // 关闭弹窗
    closeDialog() {
      this.pointProps.visible = false
      this.$emit('cancel')
    },
    // 获取风险点列表
    async getList() {
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
        chapterId: this.currentNode.chapterId ? this.currentNode.chapterId : null,
        bankId: this.currentNode.chapterId ? null : this.currentNode.id,
      }
      this.tableLoading = true
      const [err, res] = await questionSourceApi.pagedListQuery(data)
      if (!err) {
        this.dataList = map(res.items, (item) => {
          this.questionImportantList.forEach((important) => {
            if (parseInt(important.code, 10) === item.importance) {
              item.importantName = important.displayName
            }
          })
          item.chapterName = find(this.chapterList, { id: item.chapterId })?.value || ''
          return item
        })
        this.totalCount = res.totalCount
      }
      this.tableLoading = false
    },
    // 获取章节数据
    async getChapterList() {
      const [err, res] = await questionChapterApi.getDropDown()
      if (!err) {
        this.chapterList = res
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.chapter-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.chapter-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
